module.exports = __webpack_public_path__ + "static/img1-ed900ae38c7eea086de949072dd0d4c4.svg";